import * as React from "react";
import NextImage from "next/image";
import { Grid, GridItem, Flex } from "@chakra-ui/react";

import CustomLink from "components/Chakra/CustomLink";

interface IBrand {
  src: string;
  url: string;
  alt?: string;
}

interface IProps {
  brands: Array<IBrand>;
  colorOnHover?: boolean;
  priority?: boolean;
}

const Logos: React.FC<IProps> = ({ brands, colorOnHover, priority }) => (
  <Flex justifyContent="center">
    <Grid
      justifyItems="center"
      alignItems="center"
      gap={8}
      templateColumns={{
        base: "repeat(1, 1fr)",
        sm: "repeat(2, 1fr)",
        md: "repeat(4, 1fr)",
      }}
      templateRows="auto"
    >
      {brands.map((item, i) => (
        <GridItem key={i} justifyContent="center">
          <CustomLink
            href={item.url}
            isExternal
            filter={colorOnHover ? "grayscale(1)" : undefined}
            _hover={{ filter: "none" }}
          >
            <NextImage
              priority={priority}
              src={item.src}
              alt={item.alt || ""}
              width="170"
              height="120"
              style={{ objectFit: "contain" }}
            />
          </CustomLink>
        </GridItem>
      ))}
    </Grid>
  </Flex>
);

export default Logos;
